import React, { useEffect, useState } from 'react';

export default function BookingsNotification({ bookingsCount }) {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (typeof bookingsCount === 'number') {
      setCount(bookingsCount);
      setLoading(false);
      return;
    }
    // Only fetch independently if no bookingsCount is provided
    let isMounted = true;
    function fetchBookings() {
      fetch(`${process.env.REACT_APP_API_URL || ''}/bookings`)
        .then(res => res.json())
        .then(data => {
          if (!isMounted) return;
          // Count only active (pending) bookings
          const pending = data.filter(b => String(b.status).toUpperCase() === 'PENDING');
          setCount(pending.length);
          setLoading(false);
        })
        .catch(() => {
          if (!isMounted) return;
          setError('Failed to fetch bookings');
          setLoading(false);
        });
    }
    fetchBookings();
    // Refresh every 60 seconds
    const interval = setInterval(fetchBookings, 60000);
    return () => { isMounted = false; clearInterval(interval); };
  }, []); // Remove bookingsCount dependency

  // Separate effect to handle bookingsCount changes
  useEffect(() => {
    if (typeof bookingsCount === 'number') {
      setCount(bookingsCount);
      setLoading(false);
    }
  }, [bookingsCount]);

  if (loading) return null;
  if (error) return null;
  if (count === 0) return null;

  return (
    <div style={{
      display: 'flex', justifyContent: 'center', marginTop: 18, marginBottom: 0
    }}>
      <div style={{
        background: '#fff3cd',
        color: '#856404',
        border: '1px solid #ffeeba',
        borderRadius: 8,
        padding: '12px 32px',
        fontWeight: 600,
        fontSize: 17,
        boxShadow: '0 1px 8px #85640422',
        textAlign: 'center',
        letterSpacing: 0.5,
        zIndex: 5,
        display: 'inline-block',
        maxWidth: '100%',
        minWidth: 0
      }}>
        <span style={{marginRight:8}}>⚠️</span>
        {count === 1 ? 'There is 1 active booking requiring urgent attention.' : `There are ${count} active bookings requiring urgent attention.`}
      </div>
    </div>
  );
}
